<template>
  <div>
    <div>
      <el-button style="margin-left: 10px" type="warning" :loading="takeScreenshotBool" @click="takeScreenshot">
        {{ $t('makeSchedule.AssemblyProductionScheduling.exportPicture') }}
      </el-button>
    </div>
  <div id="download">
    <el-row style="height: 50px;align-items: center">
      <el-col :span="8" style="font-weight: bold;font-size: 23px">{{parentData.id.toString().slice(5,10).replace("-",".")}}组立生产/人员状况</el-col>
      <el-col :span="4" style="font-size: 16px">出勤：{{currentLineData.workerCnt}}</el-col>
      <el-col :span="4" style="font-size: 16px">缺勤：{{currentLineData.zuliTotalPersonCnt - currentLineData.workerCnt}}</el-col>
      <el-col :span="4" style="font-size: 16px">出勤率：{{currentLineData.attendance_rate}}</el-col>
      <el-col :span="4" style="font-size: 16px">累计生产性：{{parentData.productive}} m²/人工</el-col>
    </el-row>

    <div>
      <el-table :span-method="arraySpanMethod" :data="currentLineData.productionDetailTableList" stripe border :header-cell-style="{textAlign: 'center'}"
                :cell-style="{ textAlign: 'center', width: '99%'}" style="height: 100%">
        <el-table-column prop="line_name" label="线别" width="90" />
        <el-table-column prop="line_leader_name" label="责任人" width="90" />
        <el-table-column prop="wujian_short_name" label="物件名" min-width="130" />
        <el-table-column prop="plan" label="今日合计(计划)" width="120" />
        <el-table-column prop="actual" label="今日合计(实绩)" width="120" />
        <el-table-column label="08:00-20:00">
          <el-table-column prop="unit_cnt" label="单元数" width="90" />
          <el-table-column prop="unit_area" label="单元面积" width="90" />
          <el-table-column prop="line_wujian_artificial" label="出勤人工" width="90" />
          <el-table-column prop="line_wujian_productive" label="生产性" width="90" />
        </el-table-column>
        <el-table-column prop="line_productive" label="总生产性" width="90" />
        <el-table-column prop="remark" label="备注" min-width="150" />
      </el-table>
    </div>
  </div>
</div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "MfgAssemblyReportDetails",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {
      fromData: this.parentData,
      takeScreenshotBool: false,
      currentLineData:{},
    }
  },methods: {
    async takeScreenshot() {
      this.takeScreenshotBool = true
      await html2canvas(document.getElementById("download"),{
        scale: 2, // 设置放大的倍数
        useCORS: true, // 如果截图内容包含跨域图片，确保已设置CORS
      }).then(function(canvas) {
        //let tempImg = new Image();
        //tempImg.src = canvas.toDataURL()
        var dataUrl = canvas.toDataURL("image/jpeg");
        var a = document.createElement('a'); // 创建一个a节点插入的document
        var event = new MouseEvent('click') // 模拟鼠标click点击事件
        a.download = new Date().getTime(); // 设置a节点的download属性值(图片名称)
        a.href = dataUrl ; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event); // 触发鼠标点击事件
      });
      this.takeScreenshotBool = false
    },
    arraySpanMethod({rowIndex, columnIndex }) {
      if (rowIndex === this.currentLineData.productionDetailTableList.length - 1) {
        if (columnIndex === 0) {
          return [1, 3]; // 合并第1到第3列
        } else if (columnIndex === 1 || columnIndex === 2) {
          return [0, 0]; // 隐藏第2和第3列
        }
      }
    },
    // 合并单元格的逻辑
    getCurrentLineData() {
      this.$axios.post('mfg/lineData/getCurrentLineData',this.fromData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }

        this.currentLineData = res.data;
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    }
  },created() {
    this.getCurrentLineData()
  }
}
</script>

<style scoped>

</style>